import { render, staticRenderFns } from "./AddAccreditationItems.vue?vue&type=template&id=d028d310&scoped=true&"
import script from "./AddAccreditationItems.vue?vue&type=script&lang=js&"
export * from "./AddAccreditationItems.vue?vue&type=script&lang=js&"
import style0 from "./AddAccreditationItems.vue?vue&type=style&index=0&id=d028d310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d028d310",
  null
  
)

export default component.exports